import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import styled from '@emotion/styled';
import css, { get } from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { compose, background, border, display, space, shadow, layout, typography, color, flexbox } from 'styled-system';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var _excluded = ["size"];

var sx = function sx(props) {
  return css(props.sx)(props.theme);
};

var base = function base(props) {
  return css(props.__css)(props.theme);
};

var variant = function variant(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant,
      tx = _ref.tx;
  return css(get(theme, "variants.".concat(tx, ".").concat(variant)))(theme);
};

var size = function size(_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size,
      tx = _ref2.tx;
  return css(get(theme, "variants.".concat(tx, ".").concat(size)))(theme);
};

var styledSystemPropertiesCompositionCb = compose(background, border, display, space, shadow, layout, typography, color, flexbox);
var Box = styled('div', {
  shouldForwardProp: shouldForwardProp
})({
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0,
  padding: 0
}, function (_ref3) {
  var _theme$fonts, _theme$fontWeights, _theme$fontSizes;

  var theme = _ref3.theme;
  return {
    fontFamily: (theme === null || theme === void 0 ? void 0 : (_theme$fonts = theme.fonts) === null || _theme$fonts === void 0 ? void 0 : _theme$fonts.body) || 'Gilroy, Arial, sans-serif',
    fontWeight: (theme === null || theme === void 0 ? void 0 : (_theme$fontWeights = theme.fontWeights) === null || _theme$fontWeights === void 0 ? void 0 : _theme$fontWeights.body) || 'normal',
    fontSize: (theme === null || theme === void 0 ? void 0 : (_theme$fontSizes = theme.fontSizes) === null || _theme$fontSizes === void 0 ? void 0 : _theme$fontSizes.body) || '14px'
  };
}, base, sx, function (props) {
  return props.css;
}, function (_ref4) {
  var size = _ref4.size,
      restProps = _objectWithoutProperties(_ref4, _excluded);

  return styledSystemPropertiesCompositionCb(_objectSpread2(_objectSpread2({}, restProps), typeof size === 'number' || Array.isArray(size) ? {
    size: size
  } : {}));
}, size, variant);
var Flex = styled(Box)({
  display: 'flex'
});
var Center = styled(Flex)({
  justifyContent: 'center',
  alignItems: 'center'
});

export { Box as B, Center as C, Flex as F };
